


























































































import { Vue, Component } from 'vue-property-decorator'
import { Form } from 'element-ui'
import {
  getVipResignRecordList
} from '@/api/trade/trade'
import { exportJson2Excel } from '@/utils/excel'
import { formatJson, resetObjValue2NoneString, checkNoneString } from '@/utils/tool'
import moment from 'moment'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'

@Component({
  name: 'TradeVip'
})
export default class extends mixins(DateOption) {
  // api data
  private params = {
    udid: '',
    newUdid: '',
    page: 1,
    pageCount: 20
  }
  moment = moment
  // component data
  visible = false
  dateArrayCreate = ['', '']
  dateArrayExpire = ['', '']
  tableLoading = false
  tableData: any[] = []
  selectedData: any[] = []
  totalCount = 0

  // lifecycle
  created() {
    this.getTableData()
  }
  // methods
  async getTableData() {
    this.tableLoading = true
    let res: any = await getVipResignRecordList(this.params)
    this.tableData = res.data.dataList
    this.totalCount = res.data.pageInfo.totalCount
    this.tableLoading = false
  }
  async handleExcel() {
    // let res: any = await getAccountList({
    //   page: 1,
    //   pageCount: 500
    // })
    // if (res.status.code === 0) {
    //   setTimeout(() => {
    //     this['$message'].success('导出成功!')
    //   }, 200)
    // } else {
    //   this['$message'].error('导出失败!')
    //   return
    // }
    // const filterVal: string[] = [
    //   'id',
    //   'accountId',
    //   'certName',
    //   'applePwd',
    //   'iphoneCount',
    //   'itouchCount',
    //   'status',
    //   'info',
    //   'createDate',
    //   'creatorName'
    // ]
    // const theader: string[] = [
    //   'ID',
    //   '开发者账号',
    //   '证书',
    //   '专用密码',
    //   'iPhone可安装数量',
    //   'iPad可安装数量',
    //   '状态',
    //   '信息',
    //   '创建时间',
    //   '创建人'
    // ]
    // const list = res.data.dataList
    // const data = formatJson(filterVal, list)
    // exportJson2Excel(theader, data)
  }

  handleSearch() {
    if (this.tableLoading) { return false }
    let params: any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  handleReset() {
    resetObjValue2NoneString(this.params, ['page', 'pageCount'])
    this.dateArrayExpire = ['', '']
    this.dateArrayCreate = ['', '']
    this.params.page = 1
    this.getTableData()
  }
  handleSelectionChange(list: any[]) {
    console.log(list)
    this.selectedData = list
  }
}
